'use client'

import { useTranslation } from 'react-i18next'
import { Button } from '@planner/ui'

export function LanguageSwitcher() {
  const { i18n } = useTranslation()

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng)
  }

  return (
    <div className="flex gap-2">
      <Button
        variant={i18n.language === 'pl' ? 'default' : 'outline'}
        size="sm"
        onClick={() => changeLanguage('pl')}
      >
        PL
      </Button>
      <Button
        variant={i18n.language === 'en' ? 'default' : 'outline'}
        size="sm"
        onClick={() => changeLanguage('en')}
      >
        EN
      </Button>
    </div>
  )
}

